import * as React from "react";
import get from "lodash/get";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";

import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import {
  getIsMemberTierLoading,
  getMemberTierCustomer,
} from "../../reducers/methods";
import { interpolate } from "../../utils/string";

export interface TierExpirationDateProps extends ComponentBaseProps {
  action: string;
  center: string;
  classNames: string;
  isLoading: ReturnType<typeof getIsMemberTierLoading>;
  label: string;
  memberTierCustomer: ReturnType<typeof getMemberTierCustomer>;
  customText?: string;
  notAuthenticatedText?: string;
  onClick: () => void;
  style: { [styleProp: string]: string };
}

export class TierExpirationDate extends ComponentBase<TierExpirationDateProps> {
  render() {
    const {
      classNames,
      data,
      label = "tier_expiration_date",
      isEditing,
      isLoading,
      customText,
    } = this.props;

    if (isLoading) {
      return "...";
    }

    const isCustomerAuthenticated = get(data, "customer.authenticated", false);
    if (!isCustomerAuthenticated && !isEditing) {
      return (
        <div style={this.props.style}>
          {this.props.notAuthenticatedText || ""}
        </div>
      );
    }

    if (!get(data, "memberTier.expiration") && !isEditing) {
      return null;
    }

    function interpolatedExpirationText(
      data: any,
      tierExpirationText: string | undefined
    ): string {
      return interpolate(tierExpirationText || "", { ...data });
    }

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onAnimationEnd={this.resetAnimation}
        style={this.props.style}
        className={`TierExpirationDate-container  ${classNames || ""} ${
          this.state.animationClass
        }`}
        aria-label={label}
        ref={(component) => (this.component = component)}
      >
        <span className="Text-markdown-container">
          <ReactMarkdown skipHtml={true} linkTarget="_blank" plugins={[gfm]}>
            {interpolatedExpirationText(data, customText)}
          </ReactMarkdown>
        </span>
      </div>
    );
  }
}
